import { useState, CSSProperties } from "react";
import { PreviewImage } from "./PreviewImage";
import { FileUpload } from "./FileUpload";
import { Box, CircularProgress } from "@mui/material";
import { useFormContext } from "react-hook-form";

// Component props
interface IProps {
  image: string | undefined;
  imageLoading?: boolean;
  name: string;
  cssImage: CSSProperties;
  height?: string;
  iconColor?: string;
  borderColor?: string;
  letterColor?: string;
  borderRadius?: string;
  isCircle?: boolean
}

export const Image = (props: IProps) => {

  const [isEditing, setEditing] = useState(!Boolean(props.image));

  const methods = useFormContext();

  const deleteFieldImage = () => {
    methods.setValue(props.name, "");
    setEditing(true);
  };

  if (props.imageLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#f6f6f6",
          borderRadius: 1.5,
          height: "100%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {!isEditing && props.image && (
        <PreviewImage
          image={props.image}
          cssImage={props.cssImage}
          deleteFieldImage={deleteFieldImage}
          height={props.height}
        />
      )}
      {isEditing && (
        <FileUpload
          image={props.image}
          name={props.name}
          cssImage={props.cssImage}
          height={props.height}
          iconColor={props.iconColor}
          borderColor={props.borderColor}
          letterColor={props.letterColor}
          isCircle={props.isCircle}
        />
      )}
    </>

  );
};
